import './index.css'
import { useState, useEffect } from 'react'

function StatsStrip() {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/stats')
        if (!response.ok) throw new Error('Failed to fetch stats')
        const data = await response.json()
        setStats(data)
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }
    fetchStats()
  }, [])

  const formatNumber = (n) => {
    if (n == null) return '—'
    return Number(n).toLocaleString()
  }

  if (loading) {
    return (
      <section className="stats-strip" aria-label="Platform statistics">
        <div className="stats-strip-inner">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="stats-block stats-block--loading">
              <span className="stats-value">—</span>
              <span className="stats-label small-text">Loading…</span>
            </div>
          ))}
        </div>
      </section>
    )
  }

  if (error || !stats) {
    return null
  }

  const blocks = [
    { value: stats.sites, label: 'Sites crawled' },
    { value: stats.pages, label: 'Pages analysed' },
    { value: stats.ideas, label: 'Posts created' },
    { value: stats.users, label: 'Total users' },
  ]

  return (
    <section className="stats-strip" aria-label="Platform statistics">
      <div className="stats-strip-inner">
        {blocks.map(({ value, label }) => (
          <div key={label} className="stats-block">
            <span className="stats-value">{formatNumber(value)}</span>
            <span className="stats-label small-text">{label}</span>
          </div>
        ))}
      </div>
    </section>
  )
}

export default StatsStrip
